import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUtensils } from "@fortawesome/free-solid-svg-icons";

interface ShopClosedNoticeProps {
  variant?: "home" | "menu";
}

const ShopClosedNotice = ({ variant = "home" }: ShopClosedNoticeProps) => (
  <div className={`shop-closed-notice shop-closed-notice--${variant}`} role="status">
    <div className="shop-closed-notice-inner">
      <div className="shop-closed-sign" aria-hidden="true">
        <FontAwesomeIcon icon={faUtensils} />
        <span>Closed</span>
      </div>
      <div className="shop-closed-copy">
        <p className="shop-closed-title">We're closed now</p>
        <p className="shop-closed-description">
          {variant === "home"
            ? "Good food is worth the wait. Find your next favourite while we're away."
            : "Enjoy browsing. Ordering resumes when we reopen."}
        </p>
        {variant === "home" && (
          <span className="shop-closed-browse-label">Our menu is still open to explore</span>
        )}
      </div>
    </div>
  </div>
);

export default ShopClosedNotice;
